"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { Crisp } from "crisp-sdk-web"
import config from "@/config"

export const CrispChat = () => {
  const pathname = usePathname()

  useEffect(() => {
    if (config?.crisp?.id) {
      window.$crisp = []
      window.$crisp.push(["safe", true])
      Crisp.configure(config.crisp.id)

      if (
        config.crisp.onlyShowOnRoutes &&
        !config.crisp.onlyShowOnRoutes.includes(pathname)
      ) {
        Crisp.chat.hide()
        Crisp.chat.onChatClosed(() => {
          Crisp.chat.hide()
        })
      }
    }
  }, [pathname])

  return null
}